/* ConvertCart rebuild - site-wide behaviour (Sep 2026). Loaded from theme.liquid (defer). */
(function () {
  'use strict';

  /* Brand strips: arrow scrolling + disabled state at the ends. Works for strips
     that exist on load and for the nav dropdown that the theme injects via ajax. */
  function initBrands(root) {
    var strips = (root || document).querySelectorAll('[data-cc-brands]:not([data-cc-ready])');
    Array.prototype.forEach.call(strips, function (strip) {
      strip.setAttribute('data-cc-ready', '1');
      var track = strip.querySelector('[data-cc-track]');
      var prev = strip.querySelector('.cc-brands-arrow--prev');
      var next = strip.querySelector('.cc-brands-arrow--next');
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max;
        strip.classList.toggle('cc-brands--overflow', track.scrollWidth > track.clientWidth + 1);
      }
      function go(dir) {
        track.scrollBy({ left: dir * Math.max(200, track.clientWidth * 0.85), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });
      /* Mobile menu: open the brand grid's parent item by default so logos show on first tap */
      var mobileChildren = strip.closest('.mobile-nav__children');
      if (mobileChildren) {
        var parentItem = mobileChildren.closest('.mobile-nav__item');
        if (parentItem) parentItem.classList.add('open');
        mobileChildren.style.display = 'block';
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      setTimeout(update, 400);
    });
  }

  /* Desktop "Cylinder Heads" dropdown: stretch it edge to edge by offsetting the
     absolutely positioned dropdown by its containing block's page x. */
  function positionMega() {
    var drops = document.querySelectorAll('.nav__item__dropdown--cc-brands');
    Array.prototype.forEach.call(drops, function (drop) {
      var li = drop.closest('.nav__item');
      if (!li) return;
      /* left:0 resolves against the nearest positioned ancestor, not always the li */
      var cb = drop.offsetParent || li;
      var rect = cb.getBoundingClientRect();
      var w = document.documentElement.clientWidth;
      drop.style.setProperty('--cc-drop-left', (-rect.left) + 'px');
      drop.style.setProperty('--cc-drop-width', w + 'px');
    });
  }

  /* Mobile bottom bar: Search opens the header search (PartsLogic trigger or the theme's
     full search); falls back to the /search page. Body class reserves space for the bar. */
  function initMobileBar() {
    var bar = document.querySelector('.cc-mbar');
    if (!bar) return;
    document.body.classList.add('cc-has-mbar');
    var search = bar.querySelector('[data-cc-mbar="search"]');
    if (search) {
      search.addEventListener('click', function (e) {
        var trigger = document.querySelector('.header--mobile #partslogic-searchbar-trigger-mobile, .header #partslogic-searchbar-trigger-mobile, #partslogic-searchbar-trigger-mobile, .search-full-trigger');
        if (trigger) { e.preventDefault(); trigger.click(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
      });
    }
    /* Tidio renders in a shadow root: lift the bubble above the bar (mobile only) */
    var tries = 0;
    (function liftTidio() {
      if (window.innerWidth > 767) return;
      var host = document.getElementById('tidio-chat');
      var root = host && host.shadowRoot;
      if (root) {
        if (!root.getElementById('cc-mbar-lift')) {
          var st = document.createElement('style');
          st.id = 'cc-mbar-lift';
          st.textContent = '#tidio-chat-root{margin-bottom:64px!important}';
          root.appendChild(st);
        }
        return;
      }
      if (tries++ < 40) setTimeout(liftTidio, 500);
    })();
    /* cart count: the theme updates .cart-number spans itself; just track empty state */
    var count = bar.querySelector('.cc-mbar__count');
    if (count && window.MutationObserver) {
      new MutationObserver(function () { count.classList.toggle('is-empty', (parseInt(count.textContent, 10) || 0) === 0); })
        .observe(count, { childList: true, characterData: true, subtree: true });
    }
  }

  /* Value-prop cards: tap toggles the description (hover handles it on pointer devices) */
  function initValueProps() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cc-vp]'), function (wrap) {
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.cc-vp__btn');
        if (!btn) return;
        var card = btn.closest('.cc-vp__card');
        var open = !card.classList.contains('is-open');
        Array.prototype.forEach.call(wrap.querySelectorAll('.cc-vp__card.is-open'), function (c) {
          c.classList.remove('is-open');
          c.querySelector('.cc-vp__btn').setAttribute('aria-expanded', 'false');
        });
        card.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cc-vp]')) return;
      Array.prototype.forEach.call(document.querySelectorAll('.cc-vp__card.is-open'), function (c) {
        c.classList.remove('is-open');
        c.querySelector('.cc-vp__btn').setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* Testimonials: clamp long reviews and reveal on "Read more" */
  function initReadMore() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cc-readmore]'), function (body) {
      var text = body.querySelector('.cc-tm__text');
      var btn = body.querySelector('.cc-tm__more');
      if (!text || !btn) return;
      body.classList.add('is-clamped');
      if (text.scrollHeight > text.clientHeight + 2) {
        btn.hidden = false;
        btn.addEventListener('click', function () {
          var open = body.classList.toggle('is-clamped') === false;
          btn.textContent = open ? 'Read less' : 'Read more';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      } else {
        body.classList.remove('is-clamped');
      }
    });
  }

  /* Mirror the theme's sticky-header state on <body> (used by the sticky filter offset) */
  function trackStickyHeader() {
    var inner = document.querySelector('.header-sticker__inner');
    if (!inner || !window.MutationObserver) return;
    var sync = function () { document.body.classList.toggle('cc-header-sticky', inner.classList.contains('active')); };
    new MutationObserver(sync).observe(inner, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  /* Recently viewed: remember products in localStorage and render them as cards */
  function initRecentlyViewed() {
    var KEY = 'cc_recently_viewed';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    var currentEl = document.querySelector('[data-cc-rv-current]');
    var current = null;
    if (currentEl) {
      try { current = JSON.parse(currentEl.textContent); } catch (e) { current = null; }
    }
    if (current && current.handle) {
      list = list.filter(function (p) { return p.handle !== current.handle; });
      list.unshift(current);
      list = list.slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    var wrap = document.querySelector('[data-cc-rv]');
    if (!wrap) return;
    var exclude = wrap.getAttribute('data-cc-rv-exclude');
    var limit = parseInt(wrap.getAttribute('data-cc-rv-limit'), 10) || 8;
    var items = list.filter(function (p) { return p.handle !== exclude; }).slice(0, limit);
    if (!items.length) return;
    var track = wrap.querySelector('[data-cc-track]');
    track.innerHTML = items.map(function (p) {
      var esc = function (s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
      return '<a class="cc-rv__card" href="' + esc(p.url) + '">' +
        '<span class="cc-rv__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="cc-rv__name">' + esc(p.title) + '</span>' +
        '<span class="cc-rv__price">' + (p.compare ? '<s>' + esc(p.compare) + '</s> ' : '') + esc(p.price) + '</span></a>';
    }).join('');
    wrap.hidden = false;
    initBrands(wrap);
  }

  /* Cart drawer express slot: show only Apple Pay. Shopify renders every enabled wallet inside
     <shopify-accelerated-checkout-cart>, whose rows live in a closed shadow root that CSS cannot
     reach, so hiding the other wallets still leaves their rows behind. Instead we measure where the
     Apple Pay button renders and clip the slot to exactly that button (Shop Pay / PayPal / Google Pay
     remain on the cart page and at checkout). */
  function initCartExpress() {
    var APPLE = /apple/i;
    function looksApple(el) {
      if (!el || !el.getAttribute) return false;
      if (APPLE.test(el.tagName)) return true;
      var attrs = ['class', 'id', 'data-testid', 'aria-label', 'title', 'name', 'type'];
      for (var i = 0; i < attrs.length; i++) { if (APPLE.test(el.getAttribute(attrs[i]) || '')) return true; }
      return false;
    }
    function findApple(root) {
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        if (all[i].tagName === 'STYLE' || all[i].tagName === 'SCRIPT') continue;
        if (looksApple(all[i])) return all[i];
        if (all[i].shadowRoot) { var f = findApple(all[i].shadowRoot); if (f) return f; }
      }
      return null;
    }
    function hideOthers(wrap, apple) {
      var comps = wrap.querySelectorAll('shopify-accelerated-checkout-cart');
      Array.prototype.forEach.call(comps, function (comp) {
        Array.prototype.forEach.call(comp.children, function (k) {
          if (k.tagName === 'STYLE' || k.tagName === 'SCRIPT') return;
          if (k === apple || k.contains(apple)) { k.classList.add('cc-apple'); return; }
          if (k.style.display !== 'none') k.style.setProperty('display', 'none', 'important');
        });
      });
      Array.prototype.forEach.call(wrap.querySelectorAll('a'), function (a) {
        if (a !== apple && !a.contains(apple) && a.style.display !== 'none') a.style.setProperty('display', 'none', 'important');
      });
    }
    /* returns true once the Apple Pay button is rendered and the slot is aligned to it */
    function process(wrap) {
      var apple = findApple(wrap);
      if (!apple) { wrap.style.display = 'none'; return false; }
      hideOthers(wrap, apple);
      /* keep the slot in the flow (0 height, clipped) so the button can be measured */
      wrap.style.display = 'block';
      wrap.style.overflow = 'hidden';
      wrap.style.position = 'relative';
      if (!wrap.style.height) wrap.style.height = '0px';
      var er = apple.getBoundingClientRect();
      if (er.height < 10) return false;
      var comp = apple.closest('shopify-accelerated-checkout-cart') || apple.parentElement;
      var inner = wrap.firstElementChild || comp;
      var ir = inner.getBoundingClientRect();
      var shift = Math.round(er.top - ir.top);
      var t = 'translateY(' + (-shift) + 'px)';
      if (inner.style.transform !== t) inner.style.transform = t;
      var h = Math.round(er.height) + 'px';
      if (wrap.style.height !== h) wrap.style.height = h;
      return true;
    }
    function watch(wrap) {
      if (wrap.getAttribute('data-cc-express-ready')) return;
      wrap.setAttribute('data-cc-express-ready', '1');
      var tries = 0;
      (function tick() {
        var ok = process(wrap);
        if (!ok && tries++ < 40) setTimeout(tick, 250); /* wallets render async, give them ~10s */
        else if (!ok) wrap.style.display = 'none';
      })();
      /* re-align after the component re-renders or the drawer resizes */
      if (window.MutationObserver) {
        new MutationObserver(function () { process(wrap); }).observe(wrap, { childList: true, subtree: true });
      }
      [1500, 3000, 6000].forEach(function (ms) { setTimeout(function () { process(wrap); }, ms); });
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () { process(wrap); });
        Array.prototype.forEach.call(wrap.querySelectorAll('shopify-accelerated-checkout-cart, shopify-accelerated-checkout-cart > *'), function (el) { ro.observe(el); });
      }
      window.addEventListener('resize', function () { process(wrap); });
    }
    function scan() { Array.prototype.forEach.call(document.querySelectorAll('[data-cc-express]'), watch); }
    scan();
    var canvas = document.getElementById('header-cart-canvas');
    if (canvas && window.MutationObserver) {
      new MutationObserver(scan).observe(canvas, { childList: true, subtree: true });
    }
  }

  function onReady() {
    initCartExpress();
    initRecentlyViewed();
    trackStickyHeader();
    initReadMore();
    initValueProps();
    initMobileBar();
    initBrands(document);
    positionMega();
    if (window.MutationObserver) {
      Array.prototype.forEach.call(document.querySelectorAll('.main-nav, .mobile-nav'), function (nav) {
        new MutationObserver(function () { initBrands(nav); positionMega(); })
          .observe(nav, { childList: true, subtree: true });
      });
    }
    document.addEventListener('mouseover', function (e) {
      var li = e.target && e.target.closest && e.target.closest('.nav__item');
      if (li && li.querySelector('.nav__item__dropdown--cc-brands')) positionMega();
    }, { passive: true });
    window.addEventListener('resize', positionMega);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();
})();
